import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { animationLoader } from "./animationLoader";
import { unLazyLoad } from "./unlazyLoad";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { LDScrollTo } from "./scrollTo.js";
import { slideDown, slideUp } from "./slideupSlidedown.js";
import { LD_Custom_Eases } from "./customEases";
import { newElement } from "./newElement.js";
import { tapEvent, TapHandler } from "./tapCapture";

gsap.registerPlugin( ScrollTrigger, ScrollToPlugin, CustomEase );

// Establish Custom Eases
const ce = new LD_Custom_Eases();

function clearGsapProps( element, classToAdd = '' ) {
	gsap.to( element, {
		clearProps: true,
		onComplete: function() {
			if( classToAdd !== '' ) {
				element.classList.add( classToAdd );
			}
		}
	});
}

function elementExists( element ) {
	if ( typeof(element) != 'undefined' && element != null ) {
		return true;
	}
	return false;
}

function getChildren( parentElement, elementSkip = null ) {
	let children = Array.from( parentElement.children );

	if ( null !== elementSkip ) {
		return children.filter( item => {
			return item !== elementSkip;
		});
	}

	return children;
};

function getSiblings( element ) {
  return getChildren( element.parentElement, element );
}

function findSibling( initElement, selector ) {
	const sibs = getSiblings( initElement );
	let sibReturn = false;
	
	sibs.forEach( thisEl => {
		if ( true === thisEl.matches( selector ) ) {
			sibReturn = thisEl;
		}
	});

	return sibReturn;
}


function animateNavigation( menuObj ) {
  const html = document.querySelector('html');

  // Main Mobile Nav
  if ( false === menuObj.classList.contains( 'sub-menu' ) ) {
    
    if ( false === menuObj.classList.contains( 'active' ) ) {
      
      html.style.overflow = null;
      
      gsap.to( menuObj, {
        opacity: 1,
        x: "200vw",
        duration: 0.3,
        ease: 'exiting',
        onComplete: function () {
					clearGsapProps( menuObj );
        }
      });

    }
    else {
      
      html.style.overflow = "hidden";
      
      gsap.fromTo( menuObj, {
				display: 'var(--original-display)',
        duration: 0.001,
        opacity: 1,
        x: "200vw",
      }, {
        opacity: 1,
        x: "0vw",
        duration: 0.5,
        ease: 'entering',
				onComplete: function () {
					// an element with a position:fixed will not remain fixed if
					// its parent has a transform property set. 
					// in order for the ::before element to show correctly,
					// we must set the transform of the nav element to null.
					menuObj.style.transform = null;
					clearGsapProps( menuObj );
				}
      });
    }
  }
  // Sub Menus
  else {
    if ( false === menuObj.classList.contains( 'active' ) ) {
      slideUp( menuObj, 0.2 );
    }
    else {
      slideDown( menuObj, 0.3 );
    }
  }
}

document.addEventListener( "DOMContentLoaded", () => {
	// Navigation
	const menuToggle = document.querySelector('.menu-toggle');
	const navMenu = document.querySelector('.nav-menu[role="navigation"]:has(#primary-menu)');
	const menuItemsHaveChildren = navMenu.querySelectorAll('.menu-item-has-children');
	new TapHandler('.menu-item-has-children > a');
	const navSearchToggle = navMenu.querySelector('.search-toggle' );
	
	menuToggle.addEventListener('click', () => {
		if ( elementExists(navMenu) ) {
			navMenu.classList.toggle('active');
			animateNavigation( navMenu );
		}
		menuToggle.classList.toggle('active');	
	});

	if( menuItemsHaveChildren.length > 0 ) {
		let passedCenter = false;
		menuItemsHaveChildren.forEach( thisMenuItem => {
			const toggleButton = thisMenuItem.querySelector('button');
			const aLink = thisMenuItem.querySelector('a');
			const subMenu = thisMenuItem.querySelector('.sub-menu');

			if( thisMenuItem.classList.contains('split') ) {
				passedCenter = true;
			}

			if( passedCenter ) {
				subMenu.classList.add('align-right');
			}
			if( thisMenuItem.classList.contains('admin-menu') ) {
				const thisLink = thisMenuItem.querySelector('a');
				thisLink.innerHTML = `<i class="fa-solid fa-gear"></i><span>${thisLink.innerHTML}</span>`;
			}
			thisMenuItem.addEventListener('tap', event => {
				isTap = true;
				if( thisMenuItem.classList.contains('active') ) {
					toggleButton.setAttribute('aria-expanded', 'false' );
					aLink.setAttribute('aria-expanded', 'false' );
				}
				else {
					toggleButton.setAttribute('aria-expanded', 'true' );
					aLink.setAttribute('aria-expanded', 'true' );

					thisMenuItem.classList.toggle('active');
					toggleButton.classList.toggle('expanded');
				}
			});
			aLink.addEventListener('click', event => {
				if( isTap ){
					isTap = false;
					if( aLink.getAttribute('aria-expanded') === 'true' ){
						event.preventDefault();
					}
				}
			});

			toggleButton.addEventListener('click', event => {
				if( thisMenuItem.classList.contains('active') ) {
					toggleButton.setAttribute('aria-expanded', 'false' );
					aLink.setAttribute('aria-expanded', 'false' );
				}
				else {
					toggleButton.setAttribute('aria-expanded', 'true' );
					aLink.setAttribute('aria-expanded', 'true' );
				}
				thisMenuItem.classList.toggle('active');
				toggleButton.classList.toggle('expanded');
			});
		});
	}

	if ( navSearchToggle !== null ) {
		const searchForm = findSibling( navSearchToggle, 'form[role="search"]');
		const searchField = searchForm.querySelector('input[type="submit"]');
		const searchSubmit = searchForm.querySelector('button[type="submit"]');
		navSearchToggle.addEventListener( 'click', event => {
			event.preventDefault();
			navSearchToggle.parentElement.classList.toggle('active');
		});
		if ( searchSubmit !== null && searchField !== null ) {
			searchSubmit.addEventListener( 'click', event => {
				if ( searchField.value == '' ) {
					event.preventDefault();
					navSearchToggle.parentElement.classList.remove('active');
				}

			});
		}
	}

});

// The following components add their own event listeners.
unLazyLoad();
const aniLoad = new animationLoader();
const scroller = new LDScrollTo();